import { heroStats } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full">
      <div className="relative h-[560px] md:h-[660px] w-full overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20warm%20gradient%20background%20with%20soft%20film%20grain%20and%20gentle%20light%20leaks%2C%20deep%20vermillion%20red%20and%20amber%20gold%20tones%20over%20warm%20ink%20shadows%2C%20elegant%20editorial%20magazine%20cover%20texture%2C%20minimal%20moody%20atmospheric%20cinematic%20composition%2C%20high%20detail&width=1920&height=1080&seq=hero-cover-2026&orientation=landscape"
          alt="小电影在线观看高清片单氛围背景"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55" />

        <div className="relative z-10 h-full flex flex-col">
          <div className="px-4 md:px-8 pt-7">
            <div className="flex items-center gap-3 text-[11px] md:text-xs tracking-[0.25em] text-background-50/80 font-label">
              <span className="w-6 h-px bg-background-50/50" />
              第 2026 · 10 · 10 期　每周看片指南
            </div>
          </div>

          <div className="flex-1" />

          <div className="px-4 md:px-8 pb-7 md:pb-9">
            <div className="max-w-3xl animate-rise">
              <h1 className="font-heading font-black text-4xl md:text-6xl lg:text-7xl leading-[1.05] text-background-50">
                小电影在线观看
              </h1>
              <p className="mt-4 md:mt-5 text-sm md:text-base leading-relaxed text-background-50/85 max-w-2xl">
                把当前还能用的高清看片网站收进一页。无论你想找热门小电影资源，还是深夜无聊想刷片，都能在这里快速定位到能看的站点，省去四处搜网址的麻烦，打开就能直接播。
              </p>

              <div className="mt-5 md:mt-6 flex flex-wrap items-center gap-2">
                {['高清线路', '站点实时状态', '每日更新', '深夜档专区'].map((chip) => (
                  <span
                    key={chip}
                    className="text-xs md:text-sm text-background-50/90 border border-background-50/30 rounded-full px-3 py-1 whitespace-nowrap"
                  >
                    {chip}
                  </span>
                ))}
              </div>

              <div className="mt-6 md:mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <a
                  href="#sites"
                  className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer dark:text-foreground-950"
                >
                  开始看片
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-play-fill" />
                  </span>
                </a>
                <a
                  href="#ranking"
                  className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
                >
                  先看热度榜
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line" />
                  </span>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-50/15 bg-black/25 backdrop-blur-sm">
            <div className="grid grid-cols-2 md:grid-cols-4">
              {heroStats.map((stat, idx) => (
                <div
                  key={stat.id}
                  className={`px-4 md:px-8 py-4 ${idx !== heroStats.length - 1 ? 'md:border-r border-background-50/15' : ''} ${idx < 2 ? 'border-b md:border-b-0 border-background-50/15' : ''}`}
                >
                  <div className="font-heading font-bold text-2xl md:text-3xl text-background-50">{stat.value}</div>
                  <div className="mt-1 text-[11px] md:text-xs text-background-50/70 font-label tracking-wide">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}